import React from 'react';
import {
    Home,
    Star,
    User,
    Calendar,
    CalendarCheck,
    CalendarX,
    ClipboardList,
    ClipboardPen,
    Check,
    BadgeCheck,
    Milestone,
    X,
} from 'lucide-react';

import { ELeadStage } from 'src/services/api/leads';
import type { TThreadEvent, TThreadEventTone } from 'src/pages/landlord/leads/messages/components/messages-container/thread-events';

import tones from 'src/pages/landlord/leads/messages/components/messages-container/thread-event-tones.module.css';

const ICON_SIZE = 13;

const STAGE_ICONS: Record<string, React.ReactNode> = {
    [ELeadStage.NEW]: <Star size={ICON_SIZE} />,
    [ELeadStage.CONTACTED]: <User size={ICON_SIZE} />,
    [ELeadStage.TOUR_REQUESTED]: <Calendar size={ICON_SIZE} />,
    [ELeadStage.TOUR_SCHEDULED]: <Calendar size={ICON_SIZE} />,
    [ELeadStage.TOUR_COMPLETED]: <CalendarCheck size={ICON_SIZE} />,
    [ELeadStage.INVITED_TO_APPLY]: <ClipboardList size={ICON_SIZE} />,
    [ELeadStage.APPLICATION_COMPLETED]: <Check size={ICON_SIZE} />,
    [ELeadStage.APPLICATION_APPROVED]: <BadgeCheck size={ICON_SIZE} />,
    [ELeadStage.LEASE_SIGNED]: <ClipboardPen size={ICON_SIZE} />,
    [ELeadStage.NOT_INTERESTED]: <X size={ICON_SIZE} />,
    [ELeadStage.NOT_QUALIFIED]: <X size={ICON_SIZE} />,
};

const TOUR_ICONS: Record<string, React.ReactNode> = {
    cancelled: <CalendarX size={ICON_SIZE} />,
    confirmed: <CalendarCheck size={ICON_SIZE} />,
    attended: <CalendarCheck size={ICON_SIZE} />,
    missed: <CalendarX size={ICON_SIZE} />,
};

const TONE_CLASSES: Record<TThreadEventTone, string> = {
    interest: tones.interest,
    positive: tones.positive,
    negative: tones.negative,
};

export const toneClass = (tone: TThreadEventTone): string => TONE_CLASSES[tone];

export const eventIcon = (event: TThreadEvent): React.ReactNode => {
    if (event.kind === 'interest') {
        return <Home size={ICON_SIZE} />;
    }
    if (event.kind === 'tour') {
        return (event.tourOutcome && TOUR_ICONS[event.tourOutcome]) || <Calendar size={ICON_SIZE} />;
    }
    return (event.stageValue && STAGE_ICONS[event.stageValue]) || <Milestone size={ICON_SIZE} />;
};

export const eventTooltip = (event: TThreadEvent): string => (
    event.originDetail ? `${event.detail} — ${event.originDetail}` : event.detail
);
